export const genres = [
  "全部",
  "科幻",
  "悬疑",
  "剧情",
  "动作",
  "爱情",
  "犯罪",
  "战争",
  "奇幻",
  "动画",
];

export const scenarios = [
  {
    icon: "ri-user-line",
    title: "一个人静静看",
    description:
      "不需要热闹，只想被一个故事慢慢包裹。挑节奏偏慢、情绪绵长的作品，看完还能回味一会儿。",
    movieIds: ["m03", "m09"],
  },
  {
    icon: "ri-group-line",
    title: "和朋友一起看",
    description:
      "要能一起讨论、一起紧张。节奏明快、场面利落的片子最不容易冷场，也很适合边看边猜。",
    movieIds: ["m05", "m04"],
  },
  {
    icon: "ri-home-heart-line",
    title: "全家一起看",
    description:
      "画面温暖、内容干净、时长短一些。老人小孩都能看进去，看完还能一起聊很久。",
    movieIds: ["m12", "m06"],
  },
  {
    icon: "ri-lightbulb-flash-line",
    title: "想被烧脑一下",
    description:
      "喜欢跟着线索推理、享受反转揭晓的瞬间。这两部都是细节经得起反复琢磨的类型。",
    movieIds: ["m08", "m02"],
  },
];

export const mustWatch = [
  {
    rank: 1,
    movieId: "m12",
    review:
      "全片没有一句多余的台词，手绘画面在银幕上几乎会发光。适合第一次带孩子进影院，也适合成年人独自补一场温柔的梦。",
  },
  {
    rank: 2,
    movieId: "m01",
    review:
      "把科幻拍成了安静的诗。摄影和声音设计是最大加分项，建议挑一块好屏幕、戴上耳机再看一遍。",
  },
  {
    rank: 3,
    movieId: "m03",
    review:
      "用三个时代讲一个家庭，情绪全靠留白。不急不躁的叙事，反而让人看完久久说不出话。",
  },
  {
    rank: 4,
    movieId: "m08",
    review:
      "叙事干净、光影讲究，结尾处理得极利落。喜欢推理解谜的观众可以放心冲。",
  },
  {
    rank: 5,
    movieId: "m11",
    review:
      "战争片里少见的克制与真诚，群像立得住，战斗调度扎实，情绪后劲很足。",
  },
];

export const trending = [
  { movieId: "m07", heat: 96, trendLabel: "本周飙升" },
  { movieId: "m02", heat: 89, trendLabel: "口碑回温" },
  { movieId: "m04", heat: 84, trendLabel: "讨论度高" },
  { movieId: "m05", heat: 78, trendLabel: "持续上榜" },
  { movieId: "m06", heat: 72, trendLabel: "新晋热门" },
  { movieId: "m10", heat: 68, trendLabel: "话题之作" },
];

export const newReleases = [
  {
    date: "10月08日",
    title: "深海信标",
    note: "深海科考题材，封闭空间张力十足，上线首周讨论度持续走高。",
    tag: "新片上线",
  },
  {
    date: "10月01日",
    title: "雾都迷踪",
    note: "犯罪双线叙事，港口城市的压抑氛围是本片最大看点。",
    tag: "口碑上升",
  },
  {
    date: "09月24日",
    title: "春日便利店",
    note: "深夜便利店里的暧昧与温柔，适合周末放松一口气看完。",
    tag: "轻松取向",
  },
  {
    date: "09月17日",
    title: "百鬼夜行帖",
    note: "东方奇幻美学新尝试，美术与灯光设计被反复提起。",
    tag: "视觉惊喜",
  },
];

export const viewingGuide = [
  {
    icon: "ri-compass-3-line",
    title: "先定需求，再挑片子",
    description:
      "找片之前先想清楚今晚想要什么：是想被逗笑、被惊到，还是想安安静静地被感动。目标越清晰，选中合适片子的概率就越高。",
    points: ["放松解压 → 动作、喜剧", "烧脑推理 → 悬疑、犯罪", "情绪沉淀 → 剧情、战争"],
  },
  {
    icon: "ri-star-line",
    title: "评分要看，但别只看分",
    description:
      "高分是重要参考，却不一定适合你。建议把评分和类型标签结合起来看，再快速扫一眼简介，判断口味是否对得上。",
    points: ["评分 + 类型双筛选", "留意简介里的关键设定", "小众类型分浮动大"],
  },
  {
    icon: "ri-timer-line",
    title: "按时间与状态安排",
    description:
      "时间充裕时可以选长片、慢节奏的作品；只有零碎时间就挑 100 分钟以内的轻松片，观感会舒服很多。",
    points: ["碎片时间 → 100 分钟内", "完整周末 → 长片细看", "睡前 → 轻松治愈向"],
  },
  {
    icon: "ri-shield-check-line",
    title: "学会快速避开烂片",
    description:
      "当你发现简介全是空话、卖点只剩演员、评价集中在同一句话时，基本可以礼貌地划走，把时间留给更值得的作品。",
    points: ["警惕只有口号式宣传的片", "评论区高度雷同要留意", "系列续作看口碑再定"],
  },
];

export const faqs = [
  {
    q: "风驰影院的这份片单是怎么整理出来的？",
    a: "这是一份人工整理并持续维护的观影参考清单，把不同类型的代表作、近期高讨论度作品和长期口碑佳作放在一起。它不追求收录全部影片，而是帮助你在选片时快速建立方向。",
  },
  {
    q: "榜单里的评分是来自哪个平台？",
    a: "页面中的评分是综合参考分，用于展示不同作品之间的相对高低，方便你排序比较。不同平台的评分口径并不完全一致，建议把它当作参考而非唯一标准。",
  },
  {
    q: "为什么有些热门电影没有出现在高分榜里？",
    a: "高分榜更看重整体口碑与完成度，而热门榜关注的是近期讨论度和观看热度，两者标准不同。一部作品完全可能热度很高，但综合评分并不靠前，因此会出现在不同的分区里。",
  },
  {
    q: "本站能直接在线观看或下载影片吗？",
    a: "不能。本站只提供选片参考与观影建议，不提供在线播放、下载或任何资源链接。请通过正规的影院、平台或版权渠道观看喜欢的作品，支持正版创作。",
  },
  {
    q: "片单的更新频率是怎样的？",
    a: "片单会根据新片上线和口碑变化定期调整，通常每周梳理一次热门与口碑趋势。你可以把本页加入收藏，隔一段时间回来看看有没有适合你的新推荐。",
  },
  {
    q: "怎样用类型筛选快速找到想看的电影？",
    a: "在「按类型找片」分区点击你想看的类型标签，下方片单会立即筛选出对应作品；再点「全部」即可恢复完整列表。筛选只作用于本页已收录的影片。",
  },
];